import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
var isExistingEntity = function(data) {
    return Object.prototype.hasOwnProperty.call(data, "id");
};
var Entity = /*#__PURE__*/ function() {
    "use strict";
    function Entity(entityName, memento) {
        _class_call_check(this, Entity);
        this.entityName = entityName;
        this.memento = memento;
    }
    _create_class(Entity, [
        {
            key: "id",
            get: function get() {
                return isExistingEntity(this.memento) ? this.memento.id : null;
            }
        },
        {
            key: "idRequired",
            get: function get() {
                if (!isExistingEntity(this.memento)) {
                    throw new Error("The ".concat(this.entityName, " entity's ID is required, but it is missing"));
                }
                return this.memento.id;
            }
        }
    ]);
    return Entity;
}();
export { Entity };
